import { fmtDateTime } from "../lib/format";
import {
  Plus, Pencil, CheckCircle2, ArrowRightLeft, StickyNote, RefreshCw, Zap, Clock,
} from "lucide-react";

const ICONS = {
  created: Plus, updated: Pencil, activity_completed: CheckCircle2,
  stage_change: ArrowRightLeft, status_change: ArrowRightLeft, note: StickyNote,
  converted: RefreshCw, activity_created: Clock,
};

export default function Timeline({ events = [] }) {
  if (!events.length)
    return <div className="text-sm text-slate-400 py-8 text-center">Nessuna interazione registrata.</div>;

  return (
    <div className="relative pl-6" data-testid="timeline">
      <div className="absolute left-[9px] top-1 bottom-1 w-px bg-slate-200" />
      {events.map((e) => {
        const Icon = ICONS[e.event_type] || Zap;
        return (
          <div key={e.id} className="relative pb-5 animate-fade-up" data-testid={`timeline-event-${e.id}`}>
            <div className="absolute -left-6 w-[18px] h-[18px] rounded-full bg-white border-2 border-teal-500 flex items-center justify-center">
              <Icon className="w-2.5 h-2.5 text-teal-600" />
            </div>
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="text-sm font-medium text-slate-800">{e.title}</p>
                {e.description && <p className="text-sm text-slate-500 mt-0.5">{e.description}</p>}
                <p className="text-xs text-slate-400 mt-1 font-mono">{fmtDateTime(e.created_at)} · {e.user_name || "Sistema"}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
